import { render, staticRenderFns } from "./clics.vue?vue&type=template&id=349fd374"
import script from "./clics.vue?vue&type=script&lang=js"
export * from "./clics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports